import React, { FC } from "react";
import { BatchStatus } from "../../../services/dashboard/dashboard.types";
import EventCount from "../EventCount";
import EventProgressBar from "../EventProgressBar";
import FailedAlert from "../FailedAlert";
import { SideDrawerLink, JustifiedRow } from "../MoaDashboard.styles";

interface TranslationStatusProps {
  name: string;
  translationItem?: BatchStatus;
  openDetailsDrawer?: () => void;
  openFailedDrawer: () => void;
  isLoading: boolean
}

const TranslationStatus: FC<TranslationStatusProps> = (
    {
      name,
      translationItem,
      openDetailsDrawer,
      openFailedDrawer,
      isLoading
    }
) => {
  return (
      <>
        {!!translationItem && translationItem.total !== 0 &&
          <JustifiedRow>
            {isLoading || translationItem.total === translationItem.processed
                ? <EventCount
                    label={`${name} translated`}
                    count={translationItem.total}
                    isLoading={isLoading}
                    testId={`translationEventsCounter`}
                />
                : <EventProgressBar
                    name={name}
                    processed={translationItem.processed}
                    total={translationItem.total}
                />
            }
            {translationItem.failed > 0
                ? <FailedAlert
                    count={translationItem.failed}
                    openDrawer={openFailedDrawer}
                    id={name}
                />
                : !!openDetailsDrawer &&
                  <SideDrawerLink
                    label={`See details`}
                    to={''}
                    onClick={openDetailsDrawer}
                  />
            }
          </JustifiedRow>
        }
      </>
  )
}

export default TranslationStatus;